import { memo } from 'react';

const WhiteGloveDelivery = (props) => {
  const { color = '#666666', size = 16 } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.31348 7.08301L10.4199 8.61621C11.1666 8.89623 11.666 9.61702 11.666 10.417H13C14.1065 10.4172 15 11.3104 15 12.417V13.083L9.66602 14.75L5 13.457V14.417H1V7.08301H6.31348ZM5 8.41699V12.0703L9.64648 13.3564L13.5996 12.1299C13.493 11.91 13.2598 11.757 13 11.7568H9.43262C9.07278 11.7568 8.71973 11.6963 8.37988 11.583L6.79297 11.0566L7.21289 9.79004L8.7998 10.3164C9.0066 10.3831 10.333 10.417 10.333 10.417C10.333 10.1704 10.1797 9.94997 9.95312 9.86328L6.07324 8.41699H5ZM2.33301 8.41699V13.083H3.66602V8.41699H2.33301Z"
        fill={color}
      />
      <path
        d="M14.083 9.75H12.583V3.5H6.08301V6.25H4.58301V2H14.083V9.75Z"
        fill={color}
      />
    </svg>
  );
};

export default memo(WhiteGloveDelivery);
